import clsx from "clsx";
import { useContext, useState, useRef } from "react";

import { InfoDialog } from "../components/welcome/info-dialog";
import { ClassroomContext } from "../components/classroom.context";
import { Page } from "../components/page";
import translate from "../locales";

export function WelcomePage({ onNext }) {
  const dialogRef = useRef();
  const { setField } = useContext(ClassroomContext);
  const [groupCode, setGroupCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!groupCode) return;

    setField("groupCode", groupCode);
    onNext();
  };

  return (
    <Page className="page--welcome" logoType="normal">
      <title>{translate("welcome.page-title")}</title>
      <div className={clsx("page__content page__content--padded")}>
        <InfoDialog translationScope={["welcome", "info"]}>
          <button
            className={clsx("button")}
            onClick={() => dialogRef.current.showModal()}
          >
            {translate("welcome.info.start")}
          </button>
        </InfoDialog>

        <dialog className={clsx("dialog")} ref={dialogRef}>
          <form className={clsx("dialog__body")} onSubmit={handleSubmit}>
            <div className={clsx("dialog__header")}>
              <label className={clsx("dialog__title")} htmlFor="groupCodeInput">
                {translate("welcome.classroom.title")}
              </label>
              <p className={clsx("dialog__subtitle")}>
                {translate("welcome.classroom.description")}
              </p>
            </div>
            <div className="dialog__input input">
              <input
                autoFocus
                className="input__field"
                id="groupCodeInput"
                type="text"
                placeholder={translate("welcome.classroom.placeholder")}
                value={groupCode}
                onChange={(e) => setGroupCode(e.target.value)}
                maxLength={25}
              />
              <span className="input__helper">
                {translate("exercise.ui.text-input-footer", {
                  count: groupCode.length,
                  limit: 25,
                })}
              </span>
            </div>
            <button className={clsx("button", "dialog__action")} type="submit">
              {translate("welcome.classroom.start")}
            </button>
          </form>
        </dialog>
      </div>
    </Page>
  );
}
